import axiosServices from 'utils/axios';

export async function fetchProviderStatus() {
  const response = await axiosServices.get('/v1/provider-status');
  return response.data;
}
